import { render, staticRenderFns } from "./JourneyCaseModal.vue?vue&type=template&id=05fda30a&scoped=true"
import script from "./JourneyCaseModal.vue?vue&type=script&lang=js"
export * from "./JourneyCaseModal.vue?vue&type=script&lang=js"
import style0 from "./JourneyCaseModal.vue?vue&type=style&index=0&id=05fda30a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05fda30a",
  null
  
)

export default component.exports